import LoanSimulatorPage from "../../shared/LoanSimulatorPage";

const OperatorLoanSimulatorPage = () => (
  <LoanSimulatorPage
    showCapacityInput
    subtitle="ظرفیت نیروگاه را وارد کنید و سناریوهای مختلف مبلغ وام و اقساط را برای راهنمایی متقاضی بررسی کنید."
  />
);

export default OperatorLoanSimulatorPage;
